import * as React from "react"
import styled from "styled-components"

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes"

import Flex from "./flex.js"
import Row from "./row.js"
import Text from "./text.js"
import View from "./view.js"
import {StyledLabel} from "./styled.js"

const Title = styled(Text).attrs({
  fontSize: "title",
})``

const Content = props => {
  const {buttons, children, close, reachID, title} = props
  return (
    <>
      <Row borderBottom="default">
        <Flex>
          <Title id={reachID}>{title}</Title>
        </Flex>
        <Flex nogrow>
          <FontAwesomeIcon
            icon={faTimes}
            size="lg"
            onClick={close}
            style={{cursor: "pointer"}}
          />
        </Flex>
      </Row>
      <Row mt={4} justifyContent="center">
        <View width="90%" nogrow noshrink>
          {children}
        </View>
      </Row>
      <Row justifyContent="flex-end" mt={3} pr="5%">
        {buttons}
      </Row>
    </>
  )
}

const Column = props => {
  const {label, children} = props
  return (
    <>
      <StyledLabel>{label}</StyledLabel>
      <Row mt={2}>{children}</Row>
    </>
  )
}

export {Column, Content, Title}
